export function tagListBuilder(data) {
  return data?.map(tag => {
    return {
      refTag: tag?.refTag,
      name: tag?.name
    };
  });
}
